export default "__VITE_ASSET__06566a10__"